<template>
  <div class="cases">
    <img src="/images/TenHkwi.jpg" alt="Case Banner" class="banner-img banner-img__black" />
    <h1 class="banner-img__header text-center">Case Studies</h1>

    <div class="container">
      <div class="cases__box">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <img :src="cases[0].img" alt="Fiji Case" class="cases__img" />
          </div>
          <div class="col-lg-6 col-md-12">
            <h2 class="cases__companyName mx-3">{{ cases[0].title }}</h2>
            <p class="cases__text m-3" align="justify">{{ cases[0].p3 }}</p>
            <div class="text-start mx-3">
              <DinamicLink url="/cases/fiji" name="Read more" />
            </div>
          </div>
        </div>
      </div>

      <div class="cases__box">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <h2 class="cases__companyName mx-3">{{ cases[2].title }}</h2>
            <p class="cases__text m-3" align="justify">{{ cases[2].p5 }}</p>
            <div class="text-end mx-3">
              <DinamicLink url="/cases/argentina" name="Read more" />
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <img :src="cases[2].img" alt="Colgate Case" class="cases__img" />
          </div>
        </div>
      </div>

      <div class="cases__box">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <img :src="cases[1].img" alt="Lebanon Case" class="cases__img" />
          </div>
          <div class="col-lg-6 col-md-12">
            <h2 class="cases__companyName mx-3">{{ cases[1].title }}</h2>
            <p class="cases__text m-3" align="justify">{{ cases[1].p3 }}</p>
            <div class="text-start mx-3">
              <DinamicLink url="/cases/lebanon" name="Read more" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <EventsComponent />
    <GetInTouch />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@vueuse/head'
import cases from '@/data/casesInfo.json'

import DinamicLink from '@/components/DinamicLink.vue'
import EventsComponent from '@/components/EventsComponent.vue'
import GetInTouch from '@/components/GetInTouch.vue'

useHead({
  title: 'Cases - inte-QT',
  meta: [
    { name: 'title', content: 'Cases - inte-QT' },
    { name: 'description', content: 'Case studies where you can see the experience we offer our customers' },
    { rel: 'canonical', href: 'https://www.inte-qt.com/cases' },
  ],
})

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>

<style scoped>

.cases {
  color: #000;
  margin-top: 5rem;
  overflow-x: hidden;
}

.banner-img {
  width: 100%;
  display: block;
}

.banner-img__header {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  line-height: 1.5;
  font-size: 4rem;
  font-weight: 1000;
  color: #fff;
  text-align: center;
  z-index: 1;
}

@media (max-width: 992px) {
  .banner-img__header {
    font-size: 3rem;
    top: 31%;
    width: 90%;
  }
}

@media (max-width: 768px) {
  .banner-img__header {
    font-size: 2.2rem;
    top: 30%;
  }
}

@media (max-width: 480px) {
  .banner-img__header {
    font-size: 1.8rem;
    top: 30%;
    width: 95%;
  }
}

.cases__box {
  border-radius: 15px;
  transition: all 0.5s ease-in-out;
  margin: 15vh 0;
  overflow: hidden;
}

.cases__box:hover {
  box-shadow: 5px 5px 5px 5px #888888;
}

.cases__companyName {
  margin: 2rem 0;
  font-size: 1.8rem;
}

.cases__text {
  font-size: 1rem;
  line-height: 1.6;
}

@media (min-width: 992px) {
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
}

.cases__img {
  border-radius: 15px;
  width: 100%; 
}

@media (min-width: 1200px) {
  .cases__box {
    margin-top: 15vh;
  }

  .cases__companyName {
    font-size: 2rem;
  }

  .cases__text {
    font-size: 1rem;
  }

  .cases__img {
    width: 100%;
  }
}

@media (max-width: 1199px) and (min-width: 768px) {
  .cases__box {
    margin-top: 10vh;
  }

  .cases__companyName {
    font-size: 1.6rem;
  }

  .cases__text {
    font-size: 0.95rem;
  }

  .cases__img {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .cases {
    margin-top: 2rem;
  }

  .cases__box {
    margin-top: 4vh;
  }

  .cases__companyName {
    font-size: 1.4rem;
    text-align: center;
  }

  .cases__text {
    font-size: 0.9rem;
    padding: 0 1rem;
    text-align: justify;
  }

  .cases__img {
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>
